module.exports = __webpack_public_path__ + "img/wineglasses.1e586dbf.jpg";